import {
  formatAutoTaggingPlanValues,
  formatConceptCodeToLabel,
  resolvePlanSubTypeDisplayName,
  resolvePlanTypeDisplayName,
  type AutoTaggingPlanRecord,
  type AutoTaggingPlanTypeOption,
} from "../../../services/autoTaggingService";
import type { TaggingPlanRow } from "../constants";

export function mapTaggingPlanRow(
  plan: AutoTaggingPlanRecord,
  planTypes: AutoTaggingPlanTypeOption[] = [],
): TaggingPlanRow {
  return {
    id: plan.id,
    objectType: plan.target_type,
    objectSubType: plan.sub_type,
    objectTypeName: resolvePlanTypeDisplayName(planTypes, plan.target_type),
    objectSubTypeName: resolvePlanSubTypeDisplayName(
      planTypes,
      plan.target_type,
      plan.sub_type,
    ),
    conceptCode: plan.concept,
    concept: formatConceptCodeToLabel(plan.concept),
    values: formatAutoTaggingPlanValues(plan),
    description: plan.prompt,
    enabled: plan.active,
    allValues: plan.all_values,
    conceptValues: plan.concept_values,
  };
}
